import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class OnlyWebGuard implements CanActivate, CanLoad {
  constructor(private router: Router, private storageService: StorageService) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkPermissions();
  }

  public canLoad(route: Route, segments: UrlSegment[]): boolean {
    return this.checkPermissions();
  }

  private checkPermissions(): boolean {
    if (!Capacitor.isNativePlatform()) {
      return true;
    } else {
      if (this.storageService.get('token')) {
        this.router.navigate(['auth']);
      } else {
        this.router.navigate(['/activation/welcome']);
      }
      return false;
    }
  }
}
